<template>
  <div class="flash flash--modal">
    <!-- Modal -->
    <div
      :class="modelValue ? 'show' : ''"
      class="modal modal--flash fade"
      id="flashModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="flashModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <template v-if="status">
            <div class="modal-bg">
              <img src="/static/images/default/bg-popup-success.jpg" alt="" />
            </div>
          </template>

          <template v-else>
            <div class="modal-bg">
                <img src="/static/images/default/bg-popup-error.jpg" alt="" />
            </div>
          </template>
          <div class="modal-header justify-content-end border-0 pt-2 pb-0">
            <button
              class="btn btn--icon"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
            <i class="fal fa-times fs-4"></i>
            </button>
          </div>

          <div class="modal-body">
           
              <template v-if="status">
                <!-- Success message block -->
                <div>
                  <span class="mb-3">
                    <img src="/static/images/default/success.png" alt="" />
                  </span>
                </div>
                <div class="modal-content-text">
                  <span class="d-block text-black h6 fw-semibold mb-3">
                    SUCCESSFULLY <span class="heading-hightlight">! </span>
                  </span>
                  <span class="d-block" v-html="message"></span>
                </div>
              </template>

              <template v-else>
                <!-- Error message block -->
                <div>
                  <span class="mb-3">
                    <img src="/static/images/default/fail.png" alt="" />
                  </span>
                </div>
                <div class="modal-content-text">
                <span class="d-block text-black h6 fw-semibold mb-3">
                    ERROR <span class="heading-hightlight">! </span>
                  </span>
                <span class="d-block">
                  {{ message }}
                </span>
            </div>
              </template>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  title: {
    type: String,
  },
  message: {
    type: String,
  },
  status: {
    type: Boolean,
  },
  modelValue: {
    type: Boolean,
  },
});

const emit = defineEmits(["update:modelValue"]);

const closeModal = () => {
  const modal = document.getElementById("flashModal");
  modal.classList.remove("show");
  emit("update:modelValue", false);
};
</script>

<style lang="scss" scoped>
.modal--flash {
  background: rgba(0, 0, 0, 0.5);
}

.modal--flash.show {
  display: block;
}

.flash__icon {
  font-size: 10rem;
}

.flash .modal--flash .close {
  opacity: 1;
}
.modal-body{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.modal-content {
  overflow: hidden;
  min-height: 415px;
  font-size: 16px;
  text-align: center;
  color: #000;
}
.modal-content-text {
    min-height: 150px;
}
.modal-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
